import { Component, Input, OnInit } from '@angular/core';
import { environment } from '../../../../../../../environments/environment';
import { ContentLocation } from '../../translator/outbound-translator';

@Component({
  selector: 'app-location',
  templateUrl: './location-chat-bubble.component.html',
  styleUrls: ['./location-chat-bubble.component.scss'],
})
export class LocationComponent implements OnInit {
  @Input() messageSource: Boolean;

  @Input()
  content: ContentLocation;

  constructor() {}

  ngOnInit() {}

  getMapsImage(): string {
    return (
      'https://maps.googleapis.com/maps/api/staticmap?center=' +
      this.content.locationAddress +
      '&zoom=10&size=228x157&maptype=roadmap' +
      '&markers=color:red%7C' +
      this.content.latitude +
      ',' +
      this.content.longitude +
      '&key=' +
      environment['googleApiKey']
    );
  }

  openMapsView() {
    window.open(
      'https://www.google.com/maps/search/?api=1&query=' +
        this.content.latitude +
        '%2C' +
        this.content.longitude,
      '_blank'
    );
  }
}
